/**!
 * Created by Leonardo Cheslacki on 23/07/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import Moment from 'moment';

import 'moment/locale/pt-br';

Moment.locale('pt-br');

import Big from 'big.js';

// import Hammer from 'hammerjs';
//
// import TouchEmulator from 'hammer-touchemulator';
//
// import {
//     hexToRgb,
//     decomposeColor,
//     getLuminance,
//     recomposeColor,
//     emphasize
// } from '@material-ui/core/styles/colorManipulator';

import HelpersController from "./HelpersController";

let _this = {};

/**
 *
 */
class HelpersAllTap extends HelpersController {

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.props = props;
        _this = this;

        const
            {window: {location, jQuery, createjs, document}, _TITLE_, _LOCATION_, _SOURCE_} = this.props,
            _location = ((_LOCATION_ !== null) ? _LOCATION_ : location);

        this.$jQuery = jQuery;
        this.$createJs = createjs;
        this.$hours = parseInt(Moment().format('H'));
        this.$page_default = this._void;

        this.state = {
            title: _TITLE_,
            uri: `${_location.protocol}//${_location.host}${_SOURCE_}`,
            _this_index: {},
            marker_name: null
        };

        this.setAppCssIFrame(document, 'index');
    };

    /**
     *
     * @param document
     * @param name
     */
    setAppCssIFrame = (document, name) => {
        const {uri} = this.state;

        this.$jQuery(document).find(`#load_iframe_${name}`).on('load', () => {
            this.$jQuery('<link/>', {
                media: 'all',
                type: 'text/css',
                rel: 'stylesheet',
                href: `${uri}/public/css/app.min.css`
            }).appendTo(this.$jQuery(document).find(`#load_iframe_${name}`).contents().find('head'));
        });
    };

    /**
     *
     * @param document
     */
    setTitle = (document) => {
        const {title} = this.state;
        this.isElement(document) && (document.title = title);
    };

    /**
     *
     * @param object
     */
    onLoad = (object) => {
        const {full_screen, library, document} = object;
        full_screen && this.fullScreen();
        this.setState({...this.state, ...library});
        this.setTitle(document)
    };

    fullScreen = () => {
        if (this.$jQuery.isFunction(this.$jQuery.fn.confirm)) {
            const
                {window: {document}} = this.props,
                {uri} = this.state;

            this.$jQuery.confirm({
                title: `<img class="img-medium" src="${uri}/public/images/example.png" alt="logo-confirm"/>`,
                content: false,
                theme: 'supervan',
                closeIcon: false,
                animation: 'scale',
                draggable: false,
                buttons: {
                    confirm: {
                        text: 'Visualizar em tela cheia',
                        btnClass: 'btn-default',
                        action: () => {
                            this.openFullScreen(document.documentElement);
                        }
                    },
                    cancel: {
                        text: 'Não, obrigado',
                        btnClass: 'btn-default',
                        action: this._void
                    }
                }
            });
        }
    };

    /**
     *
     * @param _this_current
     * @param name
     */
    effectFadeIn = (_this_current, name) => {
        const
            {alpha_min, alpha_plus, alpha_max} = this.props,
            plus = (new Big(alpha_plus)),
            max = (new Big(alpha_max));

        _this_current[name].alpha = (new Big(alpha_min)).toNumber();

        const execute = function execute() {
            let alpha = (new Big(_this_current[name].alpha)).plus(plus).round(1, Big.roundUp);
            _this_current[name].alpha = alpha.toNumber();
            alpha.gte(max) && _this_current.removeEventListener('tick', execute);
        };

        _this_current.addEventListener('tick', execute);
    };

    /**
     *
     * @param options
     * @param objectResponse
     */
    ajax = (options, objectResponse) => {
        const {method, action, data, type} = options;

        this.$jQuery.ajaxSetup({headers: {'X-HTTP-Method-Override': (!this.isEmpty(method) ? method : 'GET')}});

        const resetFormData = (response) => {
            this.$FormData = (new FormData());
            this.inFunction(objectResponse, 'always') && objectResponse.always(response);
        };

        const execute = () => {
            this.$jQuery.ajax({
                method: method,
                url: action,
                data: this.$FormData,
                contentType: false,
                processData: false,
                dataType: (!this.isEmpty(type) ? type : 'xml'),
                beforeSend: ((typeof (objectResponse.beforeSend) === 'function') ? objectResponse.beforeSend : this._void)
            })
                .done(this.inFunction(objectResponse, 'done') ? objectResponse.done : this._void)
                .fail(this.inFunction(objectResponse, 'fail') ? objectResponse.fail : this._void)
                .always(this.inFunction(objectResponse, 'always') ? resetFormData : this._void);
        };

        if (this.isArrayIf(data)) {
            this.recursiveSyncMap(data, 0, data.length, (item, next, stop) => {
                let name = this.verifyField(item, 'name', false, false);
                if (name) {
                    this.$FormData.append(name, this.verifyField(item, 'value', false, null));
                    next(true);
                } else {
                    stop(true)
                }
            }, () => {
                execute();
            });
        } else {
            this.$FormData = undefined;
            execute();
        }
    };

    /**
     *
     * @param xml
     * @returns {{}}
     */
    xmlToJson = (xml) => {
        let object = {};

        if (xml.nodeType === 1) {
            if (xml.attributes.length > 0) {
                object['@attributes'] = {};
                this.recursiveSyncMap(xml.attributes, 0, xml.attributes.length, (item, next) => {
                    object['@attributes'][item.nodeName] = item.value;
                    next(true);
                });
            }
        } else if (xml.nodeType === 3) {
            object = xml.nodeValue;
        }

        if (xml.hasChildNodes()) {
            this.recursiveSyncMap(xml.childNodes, 0, xml.childNodes.length, (item, next) => {
                let nodeName = item.nodeName;
                if (typeof (object[nodeName]) === 'undefined') {
                    object[nodeName] = this.xmlToJson(item);
                } else {
                    if (typeof (object[nodeName].push) === 'undefined') {
                        let old = object[nodeName];
                        object[nodeName] = [];
                        object[nodeName].push(old);
                    }
                    object[nodeName].push(this.xmlToJson(item));
                }
                next(true);
            });
        }

        return object;
    };

    /**
     *
     * @param uri
     * @param callback
     */
    getXml = (uri, callback) => {
        this.ajax({method: 'GET', action: uri}, {
            done: (response) => {
                callback(this.xmlToJson(response));
            },
            fail: (response) => {
                console.log(response);
            },
            always: this._void
        });
    };

    /**
     *
     * @param occurrence
     * @param src
     */
    openTour = (occurrence, src) => {
        this.$jQuery(occurrence).on('click', () => {
            let content_tour = this.$jQuery('.content-tour');
            content_tour.addClass('animate__fadeIn');
            content_tour.find('#load_iframe_tour').attr('src', src);
            content_tour.show();
        });
    };

    closeTour = () => {
        this.$jQuery('.close-content-tour').on('click', () => {
            let content_tour = this.$jQuery('.content-tour');

            if (content_tour.hasClass('animate__fadeIn')) {
                content_tour.removeClass('animate__fadeIn');
            }

            content_tour.addClass('animate__fadeOut');

            /**
             *
             * Time control for effect
             */
            this.throttle('helpers-content-tour', () => {
                content_tour.hide();
                content_tour.removeClass('animate__fadeIn');
                content_tour.removeClass('animate__fadeOut');
                content_tour.find('#load_iframe_tour').attr('src', '');
            }, this.throttle_delay);
        });
    };

    /**
     *
     * @param array
     */
    createMenu = (array) => {
        const
            {marker_type} = this.props,
            {
                uri,
                _this_index,
                _this_index: {
                    occ_logo_large,
                    occ_logo_small,
                    occ_background,
                    occ_background_effect,
                    occ_background_dynamic
                }
            } = this.state;

        const goToAndAnimate = (name) => {
            const
                {occ_menu_marker, occ_menu_marker: {occ_animate}} = _this_index,
                {marker_name} = this.state;

            if (marker_type === 'arrow') {
                occ_menu_marker.gotoAndStop(name);
                occ_animate.play();
            } else if ((marker_type === 'strip') && (marker_name !== name)) {
                this.setStates({marker_name: name}, () => {
                    occ_animate.gotoAndPlay('out');
                });
            }
        };

        if (marker_type === 'strip') {
            this.on('animateend', (event) => {
                const
                    {marker_name} = this.state,
                    {out} = event,
                    {occ_menu_marker, occ_menu_marker: {occ_animate}} = _this_index;

                if (out) {
                    occ_menu_marker.gotoAndStop(marker_name);
                    occ_animate.gotoAndPlay('in');
                }
            });
        }

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop) => {
            let name = this.verifyField(item, 'name', false, null);
            if (!this.isEmpty(name)) {
                let btn_name = this.verifyField(item, 'button', false, null);

                if (this.isEmpty(btn_name)) {
                    let array_name = name.split('-');
                    btn_name = (this.isArrayIf(array_name) && (array_name.length > 1)) ? `btn_${array_name.join('_')}` : `btn_${array_name.join()}`;
                }

                /**
                 *
                 * If is a button video
                 */
                if (this.verifyField(item, 'occ_video', false, false)) {
                    this.$jQuery(_this_index[btn_name]).on('click', () => {
                        this.$jQuery('#load_iframe_index').attr('src', '');
                        let content_video = this.$jQuery('.content-video');
                        content_video.show();
                        content_video.find('.video-play').trigger('play');
                        goToAndAnimate(name);
                    });

                    this.$jQuery('.close-content-video').on('click', () => {
                        let content_video = this.$jQuery('.content-video');
                        content_video.toggleClass('animate__fadeIn').toggleClass('animate__fadeOut');
                        /**
                         *
                         * Time control for effect
                         */
                        this.throttle('helpers-content-video', () => {
                            if (content_video.hasClass('animate__fadeOut')) {
                                content_video.hide();
                                content_video.find('.video-play').trigger('pause').trigger('load');
                                this.$page_default();
                                content_video.toggleClass('animate__fadeOut').toggleClass('animate__fadeIn');
                            }
                        }, this.throttle_delay);
                    });
                    /**
                     *
                     * If is a button video
                     */
                } else if (this.verifyField(item, 'occ_tour', false, false)) {
                    this.$jQuery(_this_index[btn_name]).on('click', () => {
                        this.$jQuery('#load_iframe_index').attr('src', '');
                        let content_tour = this.$jQuery('.content-tour');
                        content_tour.show();
                        goToAndAnimate(name);
                    });

                    this.$jQuery('.close-content-tour').on('click', () => {
                        let content_tour = this.$jQuery('.content-tour');
                        content_tour.toggleClass('animate__fadeIn').toggleClass('animate__fadeOut');
                        /**
                         *
                         * Time control for effect
                         */
                        this.throttle('helpers-content-tour', () => {
                            if (content_tour.hasClass('animate__fadeOut')) {
                                content_tour.hide();
                                this.$page_default();
                                content_tour.toggleClass('animate__fadeOut').toggleClass('animate__fadeIn');
                            }
                        }, this.throttle_delay);
                    });
                } else {
                    let page = () => {
                        this.$jQuery('#load_iframe_index').attr('src', `${uri}/src/${name}/${name}.html`);
                        occ_logo_large && (occ_logo_large.visible = this.verifyField(item, 'occ_logo_large', false, false));
                        occ_logo_small && (occ_logo_small.visible = this.verifyField(item, 'occ_logo_small', false, false));
                        occ_background && (occ_background.visible = this.verifyField(item, 'occ_background', false, false));
                        let occ_background_effect_visible = this.verifyField(item, 'occ_background_effect', false, false);
                        occ_background_effect && (occ_background_effect.visible = occ_background_effect_visible);
                        occ_background_effect && (occ_background_effect_visible && occ_background_effect.gotoAndPlay(0));
                        occ_background_dynamic && occ_background_dynamic.gotoAndStop(name);
                        goToAndAnimate(name);
                    };

                    if (this.verifyField(item, 'page_default', false, false)) {
                        this.setState({...this.state, marker_name: name});
                        this.$page_default = page;
                    }

                    this.$jQuery(_this_index[btn_name]).on('click', page);
                    this.$jQuery(_this_index[btn_name]).on('click', page);
                }
                next(true);
            } else {
                stop(true);
            }
        });
    };

    /**
     *
     * @param occ_pin_number
     * @param number
     * @param x
     * @param y
     * @param color
     * @param font
     * @param size
     * @param weight
     */
    setPinNumber = (occ_pin_number, number, x, y, color, font, size, weight) => {
        if (this.isIntegerOrFloat(number) && this.verifyField(occ_pin_number, 'text', false, false)) {
            occ_pin_number.text = this.padWithLeadingZeros(number, 2);
        }
        if (this.isTintColor(color) && this.verifyField(occ_pin_number, 'color', false, false)) {
            occ_pin_number.color = this.tintToHex(color);
        }
        if (!this.isEmpty(font) && this.isInteger(size) && this.verifyField(occ_pin_number, 'font', false, false)) {
            occ_pin_number.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${size}px '${font}'`;
        }
        x = this.toIntegerOrFloat(x);
        if (this.isIntegerOrFloat(x) && this.verifyField(occ_pin_number, 'x', false, false)) {
            occ_pin_number.x = x;
        }
        y = this.toIntegerOrFloat(y);
        if (this.isIntegerOrFloat(y) && this.verifyField(occ_pin_number, 'y', false, false)) {
            occ_pin_number.y = y;
        }
    };

    /**
     *
     * @param occ_color
     * @param children
     * @param color
     */
    setPinColor = (occ_color, children, color) => {
        if (this.isTintColor(color) && this.isArrayIf(children)) {
            if (this.verifyField(children[0], 'graphics._fill.style', false, false)) {
                children[0].graphics._fill.style = this.tintToHex(color);
            } else if (this.verifyField(children[0], 'graphics._stroke.style', false, false)) {
                children[0].graphics._stroke.style = this.tintToHex(color);
            }
        }
    };

    /**
     *
     * @param _this
     * @param x
     * @param y
     */
    setPinCoordinate = (_this, x, y) => {
        x = this.toIntegerOrFloat(x);
        y = this.toIntegerOrFloat(y);
        this.isIntegerOrFloat(x) && (_this.x = x);
        this.isIntegerOrFloat(y) && (_this.y = y);
    };

    /**
     *
     * @param _this
     * @param enabled
     * @param cursor
     * @param uri
     */
    setPinAction = (_this, enabled, cursor, uri) => {
        _this.mouseEnabled = enabled;
        !this.isEmpty(cursor) && (_this.cursor = cursor);
        !this.isEmpty(uri) && (_this.uri = uri);
    };

    /**
     *
     * @param _this
     * @returns {{setColor(*, *): void, setAction(*, *, *): void, pin, setAnimate(*): void, clone(*): void, setCoordinate(*, *): void, setNumber(*, *, *, *, *, *, *): void, object: null}|null}
     */
    clonePin = (_this) => {
        return {
            object: null,

            /**
             *
             * @returns {null}
             */
            get pin() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pin(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            clone(name) {
                const _this_current = _this.state[`_this_${name}`], {content_pin} = _this_current;
                this.pin = content_pin.clone();
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color, font, size, weight) {
                const {occ_pin_number} = this.object;
                _this.setPinNumber(occ_pin_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const
                    occ_color = _this.verifyField(this.object, occ, false, []),
                    children = _this.verifyField(occ_color, 'children', false, []);
                _this.setPinColor(occ_color, children, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                _this.setPinCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_pin_animate} = this.object;
                occ_pin_animate.visible = visible;
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                _this.setPinAction(this.object, enabled, cursor, uri);
            }
        }
    };

    /**
     *
     * @param _this
     * @returns {{setColor(*, *): void, setAction(*, *, *): void, setAnimate(*): void, clone(*): void, setCoordinate(*, *): void, pinText, setNumber(*, *, *, *, *, *, *): void, object: null, setText(*, *, *, *, *): void}|null}
     */
    clonePinText = (_this) => {
        return {
            object: null,

            /**
             *
             * @returns {null}
             */
            get pinText() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pinText(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            clone(name) {
                const _this_current = _this.state[`_this_${name}`], {content_pin_text} = _this_current;
                this.pinText = content_pin_text.clone();
            },

            /**
             *
             * @param string
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setText(string, color, font, size, weight) {
                const {occ_text} = this.object;
                if (!_this.isEmpty(string) && _this.verifyField(occ_text, 'text', false, false)) {
                    occ_text.text = string.toString();
                }
                if (_this.isTintColor(color) && _this.verifyField(occ_text, 'color', false, false)) {
                    occ_text.color = _this.tintToHex(color);
                }
                if (!_this.isEmpty(font) && _this.isInteger(size) && _this.verifyField(occ_text, 'font', false, false)) {
                    occ_text.font = `${(!_this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${size}px '${font}'`;
                }
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color, font, size, weight) {
                const {occ_pin: {occ_pin_number}} = this.object;
                _this.setPinNumber(occ_pin_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const
                    {occ_pin} = this.object,
                    occ_color = _this.verifyField(occ_pin, occ, false, []),
                    children = _this.verifyField(occ_color, 'children', false, []);
                _this.setPinColor(occ_color, children, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                _this.setPinCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_pin: {occ_pin_animate}} = this.object;
                occ_pin_animate.visible = visible;
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                _this.setPinAction(this.object, enabled, cursor, uri);
            }
        }
    };

    /**
     *
     * @param current
     * @param name
     * @param single
     */
    createMarkers = (current, name, single) => {
        let current_name = (this.isEmpty(single) ? `${name}` : `${current}`);

        const
            {
                pin_default_color_enabled,
                pin_default_color_disabled,
                pin_round_default_color,
                pin_text_default_color,
                //pin_text_default_x,
                pin_text_default_y,
                pin_text_default_font,
                pin_text_default_size,
                pin_text_default_weight
            } = this.props,
            {uri} = this.state,
            _this_current = this.state[`_this_${current_name}`],
            {properties} = this.state[`_this_${current_name}_library`],
            {
                currentFrame,
                occ_modal,
                occ_modal_background,
                btn_close
            } = _this_current;

        let
            current_frame = this.padWithLeadingZeros(currentFrame, 2),
            content_plant = _this_current[`content_plant_${current_frame}`],
            content_text = _this_current[`content_text_${current_frame}`];

        content_text.removeAllChildren();
        content_plant.content_btn.removeAllChildren();

        this.getXml(`./src/${(!this.isEmpty(current) ? `${current}` : ``)}${(this.isEmpty(single) ? `/${current_name}` : ``)}/${name}.xml`, (response) => {
            let
                bitmap = null,
                children_temp = null,
                array = this.verifyField(response, 'products.product', false, []),
                pin_default_color = pin_default_color_disabled;

            /**
             * Clone pin text
             */
            let
                //X = 0;
                Y = 0;

            this.recursiveSyncMap(array, 0, array.length, (item, next) => {
                const pin = this.clonePin(this), pin_text = this.clonePinText(this);

                (image && status) && (pin_default_color = pin_default_color_enabled);

                /**
                 * Clone pin
                 */
                pin.clone(current_name);
                pin.setNumber(this.verifyField(item, 'itemPin.#text', false, 0), null, 12.2, null, null, null, null);
                pin.setColor(this.verifyField(item, 'colorPin.#text', false, pin_default_color), 'occ_pin_color');
                pin.setColor(pin_round_default_color, 'occ_pin_round');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_static');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_default');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_copy');
                pin.setCoordinate(this.verifyField(item, 'xPin.#text', false, 0), this.verifyField(item, 'yPin.#text', false, 0));

                /**
                 * Clone pin text
                 */
                pin_text.clone(current_name);

                let
                    /**
                     * Clone pin text
                     */
                    _id = this.verifyField(item, '@attributes.id', false, 0),
                    image = this.verifyField(item, 'image.#text', false, 0),
                    status = Boolean(parseInt(this.verifyField(item, 'status.#text', false, 0)));

                if (!this.isIdCompound(_id)) {
                    let text = this.verifyField(item, 'name.#text', false, false);

                    /**
                     * Clone pin text
                     */
                    pin_text.setText(text, pin_text_default_color, pin_text_default_font, pin_text_default_size, pin_text_default_weight);
                    pin_text.setNumber(this.verifyField(item, 'itemPin.#text', false, 0), null, -7.2, null, null, null, null);
                    pin_text.setColor(this.verifyField(item, 'colorPin.#text', false, pin_default_color), 'occ_pin_color');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_round');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_static');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_default');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_copy');
                    pin_text.setCoordinate(0, Y);
                    //pin_text.setCoordinate(X, 10);
                    //let count = ((text.length * 9) + 37);
                    //X += count < pin_text_default_x ? pin_text_default_x : count;
                }

                if (image && status) {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(true);
                    pin.setAction(true, 'pointer', `${uri}/${image}`);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(true);
                        pin_text.setAction(true, 'pointer', `${uri}/${image}`);
                    }

                    /**
                     *
                     * @param event
                     */
                    let execute = (event) => {
                        const image = (new Image());

                        image.addEventListener('load', () => {
                            occ_modal.x = (new Big(properties.width)).minus(new Big(_this_current.getBounds().width)).div(_this.$controller.big_division_2).round(1, Big.roundUp).toNumber();
                            occ_modal.y = (new Big(properties.height)).minus(new Big(_this_current.getBounds().height)).div(_this.$controller.big_division_2).round(1, Big.roundUp).toNumber();
                        });

                        image.src = event.currentTarget.uri;

                        bitmap && occ_modal.removeChild(bitmap);
                        bitmap = (new this.$createJs.Bitmap(image));
                        bitmap.scaleX = this.verifyField(item, 'scaleX.#text', false, 0);
                        bitmap.scaleY = this.verifyField(item, 'scaleY.#text', false, 0);
                        occ_modal.addChild(bitmap);

                        children_temp = _this_current.children;

                        _this_current.children = _this_current.children.filter((value) => {
                            return (value.name === 'btn_close' || value.name === 'occ_modal' || value.name === 'occ_modal_background');
                        });

                        occ_modal_background.visible = true;

                        btn_close.visible = true;

                        this.effectFadeIn(_this_current, 'occ_modal');
                    };

                    /**
                     * Clone pin
                     */
                    this.$jQuery(pin.pin).on('click', execute);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        this.$jQuery(pin_text.pinText).on('click', execute);
                    }

                    this.$jQuery(btn_close).on('click', () => {
                        bitmap && occ_modal.removeChild(bitmap);

                        _this_current.children = children_temp;

                        occ_modal_background.visible = false;

                        btn_close.visible = false;
                    });
                } else {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(false);
                    pin.setAction(false, 'default', null);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(false);
                        pin_text.setAction(false, 'default', null);
                    }
                }
                /**
                 * Clone pin
                 */
                content_plant.content_btn.addChild(pin.pin);

                /**
                 * Clone pin text
                 */
                if (!this.isIdCompound(_id)) {
                    content_text.addChild(pin_text.pinText);
                    Y += pin_text_default_y;
                }

                next(true);
            });
        });
    };

    /**
     *
     * @param document
     * @param current
     * @param array
     */
    createPaginate = (document, current, array) => {
        const {uri} = this.state;

        let pages = [];

        this.setAppCssIFrame(document, 'level_two');

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop) => {
            let name = this.verifyField(item, 'name', false, null);
            if (!this.isEmpty(name)) {
                let
                    btn_name = this.verifyField(item, 'button', false, false),
                    page_default = this.verifyField(item, 'page_default', false, false);

                if (!btn_name) {
                    let array_name = name && name.split('-');
                    btn_name = (this.isArrayIf(array_name) && (array_name.length > 1)) ? `btn_${array_name.join('_')}` : `btn_${array_name.join()}`;
                }

                if (page_default) {
                    this.$jQuery(document).find('#load_iframe_level_two').attr('src', `${uri}/src/${current}/${name}/${name}.html`);
                }

                pages.push({
                    [btn_name]: () => {
                        this.$jQuery(document).find('#load_iframe_level_two').attr('src', `${uri}/src/${current}/${name}/${name}.html`);
                    }
                });
                next(true);
            } else {
                stop(true);
            }
        }, () => {
            this.setState({...this.state, [`_this_${current}_paginates`]: pages});
        });
    };

    /**
     *
     * @param _this
     * @returns {{reference(*): void, setCoordinate(*): void, sun, object: null}|null}
     */
    reference = (_this) => {
        return {
            object: null,

            /**
             *
             * @returns {null}
             */
            get sun() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set sun(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            reference(name) {
                const _this_current = _this.state[`_this_${name}`], {
                    occ_sun,
                    parent: {input_slider}
                } = _this_current;
                this.sun = {sun: occ_sun, input: input_slider};
            },

            /**
             *
             * @param x
             */
            setCoordinate(x) {
                const {sun, input: {content_tracker: {btn_slider}}} = this.object;
                x = _this.toIntegerOrFloat(x);
                if (_this.isIntegerOrFloat(x)) {
                    sun.gotoAndStop(_this.toInteger(x));
                    btn_slider.setTransform(x);
                }
            }
        }
    };

    /**
     *
     * @param reference
     */
    syncHours = (reference) => {
        const
            {frame_min, frame_plus, frame_max} = this.props,
            plus = (new Big(frame_plus));

        let
            current = frame_min,
            frame = (new Big(frame_min));

        switch (this.$hours) {
            case 7:
                current = 50;
                break;
            case 8:
                current = 100;
                break;
            case 9:
                current = 150;
                break;
            case 10:
                current = 200;
                break;
            case 11:
                current = 250;
                break;
            case 12:
                current = 300;
                break;
            case 13:
                current = 350;
                break;
            case 14:
                current = 400;
                break;
            case 15:
                current = 450;
                break;
            case 16:
                current = 500;
                break;
            case 17:
                current = 550;
                break;
        }

        (this.$hours <= 6) && (current = 1);
        (this.$hours >= 18) && (current = frame_max);

        this.$createJs.Ticker.framerate = 1000;

        let max = (new Big(current));

        const execute = () => {
            frame = frame.plus(plus);
            reference.setCoordinate(frame.round(1, Big.roundUp).toNumber());
            frame.gte(max) && this.$createJs.Ticker.removeEventListener('tick', execute);
        };

        this.$createJs.Ticker.addEventListener('tick', execute);
    };

    $functions = {
        btnSliderMouseDown: function () {
            const {data: {_stage, btn_slider}} = _this.getListener('create-sun-mousedown');

            let
                big_mouseX = (new Big(_stage.mouseX)),
                big_scaleX = (new Big(_stage.scaleX)),
                big_x = (new Big(btn_slider.x));

            btn_slider.big_offsetX = big_mouseX.div(big_scaleX).minus(big_x);
        },
        btnSliderPressMove: function () {
            const
                {frame_min, frame_max} = _this.props,
                {data: {_stage, btn_slider, reference}} = _this.getListener('create-sun-pressmove');

            let
                big_frame_min = (new Big(frame_min)),
                big_frame_max = (new Big(frame_max)),
                big_mouseX = (new Big(_stage.mouseX)),
                big_scaleX = (new Big(_stage.scaleX)),
                big_position = big_mouseX.div(big_scaleX).minus(btn_slider.big_offsetX);

            if (big_position.gte(big_frame_min) && big_position.lte(big_frame_max)) {
                reference.setCoordinate(big_position.round(1, Big.roundUp).toNumber());
            }
        },
        /**
         *
         * @param event
         */
        canvasExtractPosition: function (event) {
            (event.type === 'touchmove') && event.preventDefault();
            const
                {frame_min, frame_plus, frame_max, position_padding} = _this.props,
                {data: {properties, input, reference}} = _this.getListener('create-sun-touchstart');

            let
                big_frame_min = (new Big(frame_min)),
                big_frame_plus = (new Big(frame_plus)),
                big_frame_max = (new Big(frame_max)),
                big_bounds_width = (new Big(input.nominalBounds.width)),
                big_position_padding = (new Big(position_padding)),
                big_input_x = (new Big(input.x)),
                big_width = _this.calcSize(properties.width, event.target.clientWidth, big_bounds_width.minus(big_position_padding).toNumber(), true),
                big_height = _this.calcSize(properties.height, event.target.clientHeight, input.nominalBounds.height, true),
                big_leftHorizontal = _this.calcSize(properties.width, event.target.clientWidth, big_input_x.plus(big_position_padding.div(_this.$controller.big_division_2)).toNumber(), true),
                big_topVertical = _this.calcSize(properties.height, event.target.clientHeight, input.y, true),
                big_rightHorizontal = big_leftHorizontal.plus(big_width),
                big_bottomVertical = big_topVertical.plus(big_height),
                big_positionX = (new Big(event.targetTouches[0].clientX)),
                big_positionY = (new Big(event.targetTouches[0].clientY)),
                //big_positionX = (new Big(event.clientX)),
                //big_positionY = (new Big(event.clientY)),
                big_positionTargetX = big_positionX.minus(big_leftHorizontal),
                //big_positionTargetY = big_positionY.minus(big_topVertical),
                big_position = big_bounds_width.minus(big_position_padding).div(big_width).times(big_positionTargetX);

            if (big_position.gte(big_frame_min) && big_position.lte(big_frame_max) && (big_positionX.gte(big_leftHorizontal) && big_positionX.lte(big_rightHorizontal)) && (big_positionY.gte(big_topVertical) && big_positionY.lte(big_bottomVertical))) {
                reference.setCoordinate((big_position.eq(big_frame_plus) ? big_frame_min : big_position.eq(big_frame_max.minus(big_frame_plus)) ? big_frame_max : big_position).round(1, Big.roundUp).toNumber());
            }
        }
    };

    /**
     *
     * @param _canvas
     * @param _stage
     * @param name
     */
    createSun = (_canvas, _stage, name) => {
        const
            reference = this.reference(this),
            {properties} = this.state[`_this_${name}_library`];

        reference.reference(name);

        const {input, input: {content_tracker: {btn_slider}}} = reference.sun;

        this.syncHours(reference);

        this.$createJs.Touch.enable(_stage);
        _stage.mouseMoveOutside = true;
        _stage.preventSelection = true;

        let
            data_touch = {
                properties: properties,
                input: input,
                reference: reference
            },
            data_mouse = {
                _stage: _stage,
                btn_slider: btn_slider
            };

        this.removeListener('mousedown', 'create-sun-mousedown', this.$functions.btnSliderMouseDown, () => {
            this.addListener(btn_slider, 'mousedown', 'create-sun-mousedown', this.$functions.btnSliderMouseDown, false, data_mouse);
        });

        this.removeListener('pressmove', 'create-sun-pressmove', this.$functions.btnSliderPressMove, () => {
            this.addListener(btn_slider, 'pressmove', 'create-sun-pressmove', this.$functions.btnSliderPressMove, false, {
                ...data_mouse,
                reference: reference
            });
        });

        this.removeListener('touchstart', 'create-sun-touchstart', this.$functions.canvasExtractPosition, () => {
            this.addListener(_canvas, 'touchstart', 'create-sun-touchstart', this.$functions.canvasExtractPosition, {passive: true}, data_touch);
        });

        this.removeListener('touchmove', 'create-sun-touchmove', this.$functions.canvasExtractPosition, () => {
            this.addListener(_canvas, 'touchmove', 'create-sun-touchmove', this.$functions.canvasExtractPosition, false, data_touch);
        });

        //_canvas.addEventListener('mousemove', extractPosition);
        //_canvas.addEventListener('touchend', extractPosition);
        //_canvas.addEventListener('touchcancel', extractPosition);
    };

    createSwipe = (_canvas, _stage, name) => {
        const
            _this_current = this.state[`_this_${name}`],
            {occ_ui, currentFrame} = _this_current,
            current_frame = this.padWithLeadingZeros(currentFrame, 2),
            _this_current_swipe = _this_current[`occ_swipe_${current_frame}`],
            {occ_plant: {x, y, scaleX, scaleY}} = _this_current_swipe;

        let
            scale = 0.01,
            scaleMax = 1,
            scaleMin = 0.1,
            speed = 10,
            button = null;

        const setScale = (scale) => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.scaleX = scale;
            occ_plant.scaleY = scale;
        }

        const setX = (speed) => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.x = speed;
        }

        const setY = (speed) => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.y = speed;
        }

        function update() {
            const {occ_plant} = _this_current_swipe;
            switch (button) {
                case 'plusButton':
                    (occ_plant.scaleX < scaleMax) && setScale(occ_plant.scaleX + scale);
                    break;
                case 'minusButton':
                    ((occ_plant.scaleX > scaleMin) && (occ_plant.scaleX > scaleX)) && setScale(occ_plant.scaleX - scale);
                    break;
                case 'leftButton':
                    setX(occ_plant.x - speed);
                    break;
                case 'upButton':
                    setY(occ_plant.y - speed);
                    break;
                case 'rightButton':
                    setX(occ_plant.x + speed);
                    break;
                case 'downButton':
                    setY(occ_plant.y + speed);
                    break;
            }
        }

        const reset = () => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.x = x;
            occ_plant.y = y;
            occ_plant.scaleX = scaleX;
            occ_plant.scaleY = scaleY;
        }

        const start = (event) => {
            button = event.target.name;
            this.$createJs.Ticker.timingMode = this.$createJs.Ticker.RAF;
            this.$createJs.Ticker.addEventListener('tick', update);
        }

        const end = () => {
            button = null;
            this.$createJs.Ticker.removeEventListener('tick', update);
        }

        occ_ui.resetButton.addEventListener('mousedown', reset);
        occ_ui.plusButton.addEventListener('mousedown', start);
        occ_ui.minusButton.addEventListener('mousedown', start);
        occ_ui.leftButton.addEventListener('mousedown', start);
        occ_ui.upButton.addEventListener('mousedown', start);
        occ_ui.rightButton.addEventListener('mousedown', start);
        occ_ui.downButton.addEventListener('mousedown', start);

        occ_ui.plusButton.addEventListener('pressup', end);
        occ_ui.minusButton.addEventListener('pressup', end);
        occ_ui.leftButton.addEventListener('pressup', end);
        occ_ui.upButton.addEventListener('pressup', end);
        occ_ui.rightButton.addEventListener('pressup', end);
        occ_ui.downButton.addEventListener('pressup', end);


        // let hammertime = new Hammer(_canvas);
        //
        // hammertime.on("panleft panright panup pandown", function(ev) {
        //     //console.log(ev.type +" gesture detected.");
        // });
        //
        // this.$createJs.Touch.enable(_stage);
        //
        // TouchEmulator();
        //
        // function log(ev) {
        //     console.log(ev);
        // }
        //
        // _canvas.addEventListener('touchstart', log, false);
        // _canvas.addEventListener('touchmove', log, false);
        // _canvas.addEventListener('touchend', log, false);
    };
}

/**
 *
 * @type {{alpha_max: Requireable<number>, _SOURCE_: Requireable<string>, alpha_min: Requireable<number>, _TITLE_: Requireable<string>, _LOCATION_: Requireable<string>, window: Requireable<object>}}
 */
const propTypes = {
    _TITLE_: PropTypes.string,
    _LOCATION_: PropTypes.string,
    _SOURCE_: PropTypes.string,
    window: PropTypes.object,
    marker_type: PropTypes.oneOf(['arrow', 'strip']),
    position_padding: PropTypes.number,
    frame_min: PropTypes.number,
    frame_plus: PropTypes.number,
    frame_max: PropTypes.number,
    alpha_min: PropTypes.number,
    alpha_plus: PropTypes.number,
    alpha_max: PropTypes.number,
    throttle_delay: PropTypes.number,
    pin_default_color_enabled: PropTypes.string,
    pin_default_color_disabled: PropTypes.string,
    pin_round_default_color: PropTypes.string,
    pin_text_default_x: PropTypes.number,
    pin_text_default_y: PropTypes.number,
    pin_text_default_color: PropTypes.string,
    pin_text_default_font: PropTypes.string,
    pin_text_default_size: PropTypes.number,
    pin_text_default_weight: PropTypes.oneOf(['normal', 'bold'])
};

/**
 *
 * @type {{default: {alpha_max: number, _SOURCE_: string, alpha_min: number, _TITLE_: string, _LOCATION_: null, window: {}}}}
 */
const config = {
    default: {
        _TITLE_: ':: TEGRA ::',
        _LOCATION_: null,
        _SOURCE_: '',
        window: {},
        marker_type: 'strip',
        position_padding: 60,
        frame_min: 0,
        frame_plus: 1,
        frame_max: 600,
        alpha_min: 0,
        alpha_plus: 0.1,
        alpha_max: 1,
        throttle_delay: 500,
        pin_default_color_enabled: '0x000000',
        pin_default_color_disabled: '0xCCCCCC',
        pin_round_default_color: '0xFFFFFF',
        pin_text_default_x: 140,
        pin_text_default_y: 36,
        pin_text_default_color: '0x5A756B',
        pin_text_default_font: 'ModeratLight',
        pin_text_default_size: 16,
        pin_text_default_weight: 'bold'
    }
};

export default (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersAllTap');
    return (new HelpersAllTap(defaultProps));
};